import { render } from "./navs.vue?vue&type=template&id=562683f8&scoped=true"
import script from "./navs.vue?vue&type=script&lang=js"
export * from "./navs.vue?vue&type=script&lang=js"

import "./navs.vue?vue&type=style&index=0&id=562683f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562683f8"]])

export default __exports__